export { default as ExitToAppOutlinedIcon } from "@mui/icons-material/ExitToAppOutlined";
